export default __webpack_public_path__ + "static/media/1362.c705236a.png";